






























import { Component, Prop, Vue } from 'vue-property-decorator';
import MainButton from '@/main-components/common/MainButton.vue';
import Modal from '@/main-components/common/modal/Modal.vue';

@Component({
  components: {
    MainButton,
    Modal,
  },
})
export default class ModalTwoButtons extends Vue {
  @Prop({ default: 'Title' })
  title: string;

  @Prop({ default: 'Description' })
  description: string;

  @Prop({ default: 'First Button' })
  firstButtonLabel: string;

  @Prop({ default: 'Second Button' })
  secondButtonLabel: string;

  @Prop({ required: true })
  onFirstClick: () => Promise<void>;

  @Prop({ required: true })
  onSecondClick: () => Promise<void>;

  isFirstLoading = false;
  isSecondLoading = false;
  openModal: any = null;
  closeModal: any = null;

  mounted() {
    this.$emit('openTwoButtonsModalAdd', this.openModal);
  }

  async onFirstClicked() {
    this.isFirstLoading = true;
    await this.onFirstClick();
    this.isFirstLoading = false;
    this.closeModal();
  }

  async onSecondClicked() {
    this.isSecondLoading = true;
    await this.onSecondClick();
    this.isSecondLoading = false;
    this.closeModal();
  }

  openModalAdd(openModal: any) {
    this.openModal = openModal;
  }

  closeModalAdd(closeModal: any) {
    this.closeModal = closeModal;
  }
}
